module.exports = __webpack_public_path__ + "img/bg-slide-0.cb7312ee.jpg";